module.exports = __webpack_public_path__ + "img/splash.6c22b246.jpg";